<template lang="html">
  <v-text-field
    ref='autocomplete'
    class='autocomplete'
    type='text'
    placeholder=''
    :value='value'
    :label='label'
    :prepend-inner-icon='icon'
    :rules='autocompleteRules'
    @input="$emit('input', $event)"/>
</template>

<script>
export default {
  props: {
    label: String,
    name: String,
    icon: String,
    value: String,
  },
  data: () => {
    return {
      autocomplete: null,
      autocompleteRules: [
        v => !!v || 'This field is required. Please make sure to select from the suggestion dropdown'
      ]
    }
  },
  mounted () {
    try {
      this.autocomplete = new google.maps.places.Autocomplete(
        /** @type {!HTML Input Element} */
        ( this.$refs.autocomplete.$refs.input ),
        { types: ['geocode'] }
      );
      this.autocomplete.addListener('place_changed', this.fillInAddress)
      this.$refs.autocomplete.$refs.input.placeholder = ''
    } catch (e) {
      alert("Issues contacting autocomplete service. Check Internet Connection and try again")
    }
  },
  methods: {
    fillInAddress () {
      var place = this.autocomplete.getPlace();
      this.$emit('input', place.formatted_address)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
